// API of the AI improvement suggestions (report 1492665d): the daily list the server makes from Bugify's past
// reports, their fixes and the work staff repeat (server services/aiSuggestions.ts). Open only to the logins
// ticked "Receives AI improvement suggestions" in Admin → Users — me.aiSuggestions — and asked for by no one
// else, since a refused call pages the admins.
import { apiRequest } from '../api';

export interface AiSuggestion {
  id: string;
  kind: 'fix' | 'suggestion';
  rank: number;                                          // 1 = most important
  title: string;
  why: string;
  screen: string;                                        // '' when it spans the whole system
  sources: { id: string; short: string; title: string }[];   // the Bugify reports it is drawn from
  state: 'open' | 'accepted' | 'dismissed';
  by_name?: string; at?: number;                         // who accepted or dismissed it, and when (unix seconds)
  bugify_id?: string;                                    // the report an accepted one was filed as
}

export interface AiSuggestionList {
  date: string;                 // 'YYYY-MM-DD' of the list; '' before the first one is made
  generated_at: number;
  reports: number;              // how many reports it was drawn from
  days: number;                 // over how many days the work was counted
  items: AiSuggestion[];
  fixes: number;                // still open — the digest pop-up's line
  suggestions: number;
  seen: boolean;                // this login has already opened or closed this day's digest
}

export const aiSuggestionsApi = {
  list: (): Promise<AiSuggestionList> => apiRequest('GET', '/ai-suggestions'),
  accept: (id: string): Promise<{ ok: true; bugify_id: string }> => apiRequest('POST', `/ai-suggestions/${encodeURIComponent(id)}/accept`),
  dismiss: (id: string): Promise<{ ok: true }> => apiRequest('POST', `/ai-suggestions/${encodeURIComponent(id)}/dismiss`),
  seen: (date: string): Promise<{ ok: true }> => apiRequest('POST', '/ai-suggestions/seen', { date }),
};
